import React, { useEffect, useState } from "react";
import {PAYMENT_ICON,CALENDER_ICON } from "assets/constants/Icons";
import MaterialTable from "material-table";
import { ThemeProvider } from '@mui/styles';
import { createTheme } from '@mui/material';
import { getPaymentTranactionListAll,getUserPaymentTranactionList } from "lib/axiosUtils";
import moment from 'moment';
import { SUPER_ADMIN } from 'assets/constants/Constants';

const PaymentTransaction = () => {

  const [transactionList, setTransactionList] = useState([]);
  const userRole = JSON.parse(localStorage.getItem("userRole"));
  const userDetail = JSON.parse(localStorage.getItem("userData"));

  useEffect(() => {
    const fetchTransactionList = async () => {
        let data;
        try {
            if (userRole.user_role === SUPER_ADMIN) {
                data = await getPaymentTranactionListAll({}, {});
            }else{
                data = await getUserPaymentTranactionList({}, {},userDetail._id);
            }

            setTransactionList(data.data.result);
        }
        catch (error) {
            console.log("error while fetching data", error);
        }
    }
        fetchTransactionList();
    },[userDetail._id, userRole.user_role]);


  const mytheme= createTheme({});
  return (<>
    {
       (
        <div className="main-content">
          <div className="pagetitle row" style={{ color: 'black', paddingTop: 15 }}>
            <div className="col-md-10 sm_device"><i className={`${PAYMENT_ICON}`}></i> Payment Transaction</div>
            <div className="col-md-2 sm_device" style={{ textAlign: 'right' }}><i className={`${CALENDER_ICON}`}></i> {moment().format("DD MMM YYYY")}</div>
          </div>
          <div style={{ borderBottom: '1px solid lightgray', marginBottom: 15, marginTop: 15 }} />
          <div className="list-wrapper">

          <div className="mt-4 border list-table-div site-table" style={{ marginBottom: 50 }}>
              {
                true ? (
                      <ThemeProvider theme={mytheme}>
                          <MaterialTable
                              columns={[
                                    {
                                        title: "Date", field: "date",
                                        cellStyle: { cellWidth: '12%', color: '#808080', fontSize: 14, textTransform: 'none' }
                                    },
                                    {
                                        title: "User", field: "user",
                                        cellStyle: { cellWidth: '12%', color: '#808080', fontSize: 14, textTransform: 'none' }
                                    },
                                    {
                                        title: "Status", field: "status",
                                        cellStyle: { cellWidth: '18%', fontWeight: 'bolder', color: '#000000', fontSize: 14, textTransform: 'none' }
                                    },
                                    {
                                        title: "Amount", field: "amount",
                                        cellStyle: { cellWidth: '18%', fontWeight: 'bolder', color: '#000000', fontSize: 14, textTransform: 'none' }
                                    },
                                    {
                                        title: "Currency", field: "currency",
                                        cellStyle: { cellWidth: '18%', color: '#808080', fontSize: 14, textTransform: 'none' }
                                    },
                                    {
                                        title: "Method", field: "method",
                                        cellStyle: { cellWidth: '20%', color: '#808080', fontSize: 14, textTransform: 'none' },
                                        sorting: false
                                    }
                              ].filter(Boolean)}
                              data={
                                transactionList.map((item) => {
                                    return (
                                        {
                                            user: item.full_name? item.full_name : `${userDetail.first_name} ${userDetail.last_name}`,
                                            amount: item.amount,  
                                            currency:item.currency,
                                            method:item.payment_method,
                                            status:item.payment_status,
                                            date: new Date(item.updated_date_time).toLocaleDateString('en-IN', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                second: '2-digit',
                                                hour12: false 
                                            }),                              
                                        }
                                    )
                                })
                            }

                              options={{
                                  actionsColumnIndex: -1,
                                  headerStyle: {
                                      color: '#999998',
                                      fontWeight: 'bolder',
                                      fontSize: 15
                                  },
                                  filtering: true,
                                  sorting: true,
                                  columnsButton: true,
                                  exportButton: true,
                                  exportFileName: "History Page Data"
                              }}
                          />
                      </ThemeProvider>
                  ) : (
                      <div className="text-center pt-2">
                          <label>Not Found</label>
                      </div>
                  )

              }
          </div>
          </div>
        </div>
      )
    }
  </>);
}

export default PaymentTransaction;